export default __webpack_public_path__ + "static/media/cpv_79_business-services.c233b205.svg";